<template>
    <div class="reviews-item">
        <div class="reviews-item-member">
            <AAvatar
                width="50"
                :src="result.photo.src"
                :alt="result.photo.alt"
                :title="result.photo.title" class="reviews-item-member__picture"/>

            <div>
                <h6 class="reviews-item-member__name">
                    {{ result.name }}
                </h6>
                <time class="reviews-item-member__date">
                    {{ result.date }}
                </time>
            </div>
        </div>
        <div class="reviews-item-content">
            {{ result.text }}
        </div>

        <div class="flex flex-end pt-3">
            <ABtn
                :label="translates.replyToComment"
                class="flat replyBtn"
                @click.native="$emit('replyTo', result.id)"
            />
        </div>

<!--        <div class="reviews-item-answers" v-if="result.replies.length">-->
<!--            <ReviewsItemAnswer-->
<!--                v-for="reply in result.replies"-->
<!--                :key="reply.id"-->
<!--                :result="reply"-->
<!--            />-->
<!--        </div>-->
    </div>
</template>

<script>
import {inject} from "vue";
import {AAvatar, ABtn} from "~/components/ui";
import ReviewsItemAnswer from "./ReviewsItemAnswer";

export default {
    name: 'ReviewsItem',
    components: {ReviewsItemAnswer, AAvatar, ABtn},
    props: ['result'],
    setup() {
        const translates = inject('translates', {})

        return {
            translates
        }
    }
}
</script>

<style lang="scss" scoped>
.reviews-item {
    border: 1px solid #E9EBED;
    background: #FFFFFF;
    border-radius: 6px;
    padding: 30px;
    transition: .2s linear box-shadow;
    @include tablet {
        padding: 30px 24px;
    }

    &:hover {
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
    }
}

.reviews-item-member {
    display: grid;
    grid-template-columns: 50px 1fr;
    grid-column-gap: 12px;
    margin-bottom: 21px;

    &__picture {
        border-radius: 50%;
    }

    &__name {
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        color: #252425;
    }

    &__date {
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #252425;
    }
}

.reviews-item-content {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.reviews-item-answers {
    display: grid;
    grid-row-gap: 26px;
    padding-top: 26px;
    margin-top: 26px;
    border-top: 1px solid #E9EBED;
}

.replyBtn {

}
</style>